import { nanoid } from "@reduxjs/toolkit";
import { View, StyleSheet, ScrollView } from "react-native";
import { useSelector } from "react-redux";
import Card from "../components/common/Card";
import ViewingEntity from "../components/common/ViewingEntity";
import CaughtUp from "../components/discover/CaughtUp";
import { RootState } from "../redux";
import { Colors, Spacing } from "../styles";

const Discover = () => {
  const insights = useSelector((state: RootState) => state.main.insights);

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={styles.inner}>
        <ViewingEntity />
        {insights.map((i) => (
          <Card key={nanoid()} id={i.id} style={{ marginBottom: 20 }} />
        ))}
        <CaughtUp />
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.plum900,
    flex: 1,
  },
  inner: {
    padding: Spacing.page,
  },
});

export default Discover;
